/**
 * Ekrandaki gercek konumu, ipucunun icinde bulundugu koordinat sistemine cevirir.
 *
 * Uygulamada 960-1600px arasi body'ye `zoom: 0.8` uygulayan bir medya sorgusu var.
 * Zoom altinda getBoundingClientRect() gorsel (ekran) pikselini dondururken,
 * position:fixed bir kutuya verdigimiz left/top ayni zoom ile carpiliyor — ipucu
 * 0.8 kati sola ve yukari kayiyordu.
 *
 * Olcegi elemanin kendisinden okuyoruz: gorsel genislik / yerlesim genisligi.
 * Boylece zoom degeri, kaynagi (zoom, transform, tarayici surumu) ne olursa olsun
 * dogru cikiyor; zoom yokken oran 1 olur ve hesap hic degismez.
 */
export default function anchorRect(el) {
    const rect = el.getBoundingClientRect();
    const measured = el.offsetWidth > 0 ? rect.width / el.offsetWidth : 1;
    const scale = measured > 0 ? measured : 1;

    return {
        left: rect.left / scale,
        top: rect.top / scale,
        centerX: (rect.left + rect.width / 2) / scale,
        viewportWidth: window.innerWidth / scale,
    };
}
